import actionTypePrefixes from "./actionTypePrefixes"
import { ENVIRONMENT } from "../../constants"

/* eslint-disable import/prefer-default-export */
// Remove eslint comment above if we add more actions (as expected)

export function loadDummyData(dashboardPrefix) {
  return {
    type: `${dashboardPrefix}DUMMY_DATA`,
  }
}

export function loadDashboardData(dashboardPrefix, filterParamsQueryString, filterLocations) {
  let apiUrl

  switch (dashboardPrefix) {
    case actionTypePrefixes.ActivityAndGeneralStats:
      apiUrl = "/reporting/dashboard/activity-and-general-stats"
      break
    case actionTypePrefixes.EmployeeEngagement:
      apiUrl = "/reporting/dashboard/employee-engagement"
      break
    case actionTypePrefixes.IntelAndInsights:
      apiUrl = "/reporting/dashboard/intel-and-insights"
      break
    case actionTypePrefixes.PeopleBalanceSheet:
      apiUrl = "/reporting/dashboard/people-balance-sheet"
      break
    case actionTypePrefixes.PerformanceAndProgression:
      apiUrl = "/reporting/dashboard/performance-and-progression"
      break
    default:
      apiUrl = "unknown-dashboard" // Should never happen
      break
  }

  // Append the filter parameters as the query string
  apiUrl += filterParamsQueryString
  if (filterLocations && filterLocations.length > 0) {
    return {
      type: `${dashboardPrefix}LOAD_DASHBOARD_DATA`,
      payload: {
        request: {
          method: "PUT",
          url: apiUrl,
          data: { LocationIds: filterLocations },
        },
      },
    }
  }
  // Hits the API to load the data, then returns a Promise
  // (for callback-like functionality - e.g. to load other dashboards in the background)
  // Dashboard specific reducers then hook into the SUCCESS/FAIL action types
  // generated by redux-axios-middleware
  if (!ENVIRONMENT.useDummyData()) {
    return {
      type: `${dashboardPrefix}LOAD_DASHBOARD_DATA`,
      payload: {
        request: {
          url: apiUrl,
        },
      },
    }
  }
  return dispatch =>
    new Promise((resolve, reject) => {
      dispatch(loadDummyData(dashboardPrefix))
      resolve()
    })
}



// WEBPACK FOOTER //
// ./src/state/actions/dashboardApiActions.js